import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/ShopifyIntegration/ShopifySetup';

const ShopifySetup = () => ((orgContainer(InnerComponent)));
export default ShopifySetup;
